import { GRAY_4, GRAY_2, GRAY_1, GRAY_LIGHT, WHITE } from './mc-tokens';

export const MODUS_DROPDOWN_MENU_STYLESHEET = `
.tc-modus-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
}
.tc-modus-dropdown-trigger-label {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}
.tc-modus-dropdown-trigger > :not(.tc-modus-dropdown-trigger-label) {
  flex-shrink: 0;
}
modus-wc-dropdown-menu.modus-wc-dropdown-menu {
  background-color: transparent !important;
}
modus-wc-dropdown-menu modus-wc-button button.modus-wc-btn {
  min-height: 2.5rem;
  min-width: 2.5rem;
  padding: 0.5rem;
  border: none;
  border-radius: 0.125rem;
}
modus-wc-dropdown-menu:has(.tc-modus-dropdown-trigger),
modus-wc-dropdown-menu:has(.tc-modus-dropdown-trigger) modus-wc-button,
modus-wc-dropdown-menu:has(.tc-modus-dropdown-trigger) button.modus-wc-btn {
  min-width: 0;
  max-width: 100%;
}

modus-wc-dropdown-menu modus-wc-button:not([aria-expanded="true"]) .modus-wc-btn-borderless.modus-wc-btn-neutral:hover:not(:disabled)  {
 background-color: ${GRAY_1} !important;
}

modus-wc-dropdown-menu modus-wc-button[aria-expanded="true"] .modus-wc-btn-borderless.modus-wc-btn-neutral:hover:not(:disabled)  {
 background-color: ${GRAY_2} !important;
}

modus-wc-dropdown-menu:not(:has(.tc-modus-dropdown-trigger)) modus-wc-button[aria-expanded="true"]  .modus-wc-btn-borderless.modus-wc-btn-neutral:not(:disabled)  {
 background-color: ${GRAY_2} !important;
}

modus-wc-dropdown-menu modus-wc-button .modus-wc-btn[disabled],
modus-wc-dropdown-menu modus-wc-button .modus-wc-btn.modus-wc-btn-disabled {
  pointer-events: inherit !important;
  
}

modus-wc-dropdown-menu modus-wc-icon:not(:defined) {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  overflow: hidden;
  color: transparent;
  font-size: 0;
  line-height: 0;
}
modus-wc-dropdown-menu .menu-wrapper {
  box-shadow: 0 0 0.375rem ${GRAY_4};
  border-radius: 0.125rem;
  background-color: ${WHITE};
  max-height: 21.5rem;
  overflow-y: auto;
}
modus-wc-dropdown-menu modus-wc-menu .modus-wc-menu {
  padding: 1rem 0 !important;
}
modus-wc-dropdown-menu modus-wc-menu hr {
  margin: 1rem 0 !important;
  border: none;
  border-top: solid 0.0625rem ${GRAY_2};
}
modus-wc-dropdown-menu modus-wc-menu hr {
  margin: 1rem 0 !important;
  border: none;
  border-top: solid 0.0625rem ${GRAY_2};
}
modus-wc-dropdown-menu modus-wc-menu-item .modus-wc-menu-item {
  height: 2.5rem;
  min-height: 2.5rem;
  padding: 0.125rem 0rem;
  & button:hover, & button:active {
    background-color: transparent !important;
  }
  &:hover {
    background-color: ${GRAY_LIGHT} !important;
    cursor: pointer;
  }
}

modus-wc-dropdown-menu modus-wc-menu-item .modus-wc-menu-item.modus-wc-menu-item-active,
modus-wc-dropdown-menu modus-wc-menu-item .modus-wc-menu-item.modus-wc-menu-item-selected {
  background-color: #cfe1ee !important;
  font-weight: 600 !important;  
  button {
   color: var(--modus-wc-color-primary) !important;
  }
}

.modus-wc-dropdown-menu .menu-wrapper .modus-wc-menu .modus-wc-menu-item .modus-wc-menu-item-content .modus-wc-menu-item-labels{
  padding-inline-start: 0rem;
  padding-inline-end: 0rem;
}

`;
